import { AdminStatus } from '../../../../../utils/constants';
import Dimens from '../../../../../theme/dimens';
import useCommonStyles from '../../../../../theme/use-common-styles';
import { useTheme } from '@mui/material';

/**
 * Custom hook that defines the styling for the AdminTableRow component.
 * It utilizes the Material-UI theme and custom common styles and dimensions.
 *
 * @returns {object} - An object containing the styling rules for different elements within the component.
 * Each property in the returned object represents a specific style rule.
 */
const useStyles = () => {

  const theme = useTheme();
  const commonStyles = useCommonStyles();
  const { xs, md, lg } = Dimens.spacing;

  const styles = {
    statusCell: (status?: AdminStatus) => ({
      display: 'flex',
      alignItems: 'center',
      color: () => {
        let color = theme.palette.text.secondary;
        if (status === AdminStatus.Active) {
          color = theme.palette.success.main;
        } else if (status === AdminStatus.Inactive) {
          color = theme.palette.error.main;
        } else if (status === AdminStatus.InProgress) {
          color = theme.palette.text.primary;
        }

        return color;
      }
    }),
    statusDot: (status: string) => ({
      height: Dimens.statusIconSize,
      width: Dimens.statusIconSize,
      borderRadius: Dimens.radius.xl,
      bgcolor: () => {
        let color = theme.palette.text.secondary;
        if (status === AdminStatus.Active) {
          color = theme.palette.success.main;
        } else if (status === AdminStatus.Inactive) {
          color = theme.palette.error.main;
        } else if (status === AdminStatus.InProgress) {
          color = theme.palette.text.primary;
        }

        return color;
      },
      mr: Dimens.spacing.sm
    }),
    inviteIcon: {
      ...commonStyles.smIcon,
      cursor: 'pointer'
    },
    binIconButton: {
      fontSize: `${Dimens.icon.sm} !important`,
      color: theme.palette.error.main,
      cursor: 'pointer',
      '&.Mui-disabled': {
        color: theme.palette.error.main,
        opacity: 0.2,
      }
    },
    binIcon: {
      ...commonStyles.smIcon,
      cursor: 'pointer'
    },
    rowWrapper: {
      ...commonStyles.borderBottom,
      display: 'flex',
      flexDirection: 'row',
      p: xs,
      alignItems: 'center',
      '& .MuiIconButton-root': {
        p: lg,
        '& svg': {
          ...commonStyles.smIcon
        }
      }
    },
    statusWrapper: {
      display: 'flex',
      flexDirection: 'row',
      pl: md,
      pr: xs
    },
    contentWrapper: {
      px: lg,
      dispaly: 'flex',
      flex: 1,
      '& p, span': {
        ...commonStyles.textEllipsis(1)
      }
    }
  };

  return styles;
};

export default useStyles;